import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['intervals']

  setCustomInterval(e) {
    this.intervalsTarget.selectedIndex = 7
  }
}
